import {
  detachLayoutProps,
  toWSDateString,
  WSCard,
  WSElement,
  WSInfoBox,
  WSMarginProps,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { DataItem } from "../../../../shared/components/DataItem";

type Props = {
  expirationDate: Date;
} & WSMarginProps;

export const ExpirationWidget: React.FC<Props> = ({
  expirationDate,
  ...other
}) => {
  const { layoutProps } = detachLayoutProps(other);

  return (
    <WSElement {...layoutProps}>
      <WSSectionToolbar title="Expiration" mb="L" />
      <WSCard>
        <WSInfoBox>
          <DataItem
            label="Expiration date"
            value={toWSDateString(expirationDate, "input")}
          />

          <WSText.ParagraphSm color="gray600" mt="M">
            This requirement has an expiration date. The renewal process will be
            available 30 days before the expiration date. Renewing during this
            period is recommended to avoid incomplete requirements and payment
            delays.
          </WSText.ParagraphSm>
        </WSInfoBox>
      </WSCard>
    </WSElement>
  );
};
